import { render, staticRenderFns } from "./resignation-list.component.vue?vue&type=template&id=09f5b2d7&scoped=true&"
import script from "./resignation-list.component.vue?vue&type=script&lang=ts&"
export * from "./resignation-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./resignation-list.component.vue?vue&type=style&index=0&id=09f5b2d7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5b2d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
